import { createFeatureSelector } from "@ngrx/store";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { GenericDeviceCardListStore } from "src/model/interface/generic-device-card-list-store";

/**
 * Selector for device card (for device in standalone version)
 */
export const listDeviceCard = createFeatureSelector<GenericDeviceCardListStore>(
  AppSettings.KEY_DEVICE_CARD_LIST
);
